<template>
    <div id="modalp-template">
      <div class="modalp-mask">
        <div class="modalp-wrapper">
          <div :class="wichModal === 'aah' ? 'modalp-container popup-large' : 'modalp-container'">
            <button class="modalp-close-button" @click="$emit('close')"><span>X</span></button>
            <div class="modalp-body-body">
              <slot name="body">
                <AlcoholAndHealth v-if="wichModal === 'aah'" name="AlcoholAndHealth" />
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>

import AlcoholAndHealth from "./AlcoholAndHealth.vue";
export default {
  name: "ModalPopup",
  components: {
    AlcoholAndHealth
  },
  props: {
    wichModal: {
      type: String,
      default: "none"
    }
  }
};
</script>
  
<style lang="scss" scoped>
@import "~@/styles/ModalAH.scss";
</style>